import React from "react";

const BirdIcon = ({ title, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 819.17 455.95"
    {...props}
  >
    {title ? <title>{title}</title> : null}
    <path d="M584.66 299.85a60.42 60.42 0 1 1-58.55-75.71h254.44a43 43 0 0 0 38.62-39.63H526.11a100 100 0 1 0 99 115.35zM483 281.81h202.34A43 43 0 0 0 724 242.18H518.23A43.54 43.54 0 0 0 483 281.81zm-248.49 18a60.41 60.41 0 1 0 58.54-75.71H38.64A43 43 0 0 1 0 184.5h293.07a100 100 0 1 1-99 115.35zm101.64-18H133.8a43 43 0 0 1-38.63-39.61H301a43.57 43.57 0 0 1 35.21 39.63zM409.59 44a184.19 184.19 0 0 1 171.47 117.25H548a153.69 153.69 0 0 0-276.81 0h-33.06A184.15 184.15 0 0 1 409.59 44zm0-44a228.22 228.22 0 0 1 218.05 161.25h-20.36a208.67 208.67 0 0 0-395.36 0h-20.37A228.19 228.19 0 0 1 409.59 0zm143.63 405A228 228 0 0 1 266 405a123.16 123.16 0 0 0 27.11 3c3.5 0 7-.14 10.41-.43a208.75 208.75 0 0 0 212.22 0q5.17.44 10.41.43a123.23 123.23 0 0 0 27.11-3z"></path>
  </svg>
);

export default BirdIcon;
